import {
  helpIcon,
  homeIcon,
  profileIcon,
  helpIconActive,
  homeIconActive,
  profileIconActive,
  chevronDown,
} from 'utils/assets';

export type TabbarItemPath = 'home' | 'profile' | 'help' | 'home-hiring' | 'profile/info' | 'profile/security' ;

interface ITabbarItem {
  path: TabbarItemPath;
  title: string;
  icon: string;
  activeIcon: string;
  isDisabled?: boolean;
  hasSubmenu?: boolean;
  submenuItems?: Array<{title: string, path: string}>;
  arrowIcon?: string;
}

export const tabbarItems: ITabbarItem[] = [
  {
    path: 'home',
    title: 'Inicio',
    icon: homeIcon,
    activeIcon: homeIconActive,
  },
  {
    path: 'home-hiring',
    title: 'Inicio',
    icon: homeIcon,
    activeIcon: homeIconActive,
  },
  {
    path: 'profile',
    title: 'Perfil',
    icon: profileIcon,
    activeIcon: profileIconActive,
    isDisabled: false,
    hasSubmenu: true,
    arrowIcon: chevronDown,
    submenuItems: [
      { title: 'Información', path: 'info' },
      { title: 'Seguridad', path: 'security' }
    ]
  },
  {
    path: 'help',
    title: 'Ayuda',
    icon: helpIcon,
    activeIcon: helpIconActive,
    isDisabled: false,
  },
];
